import { TextFilterProps } from '@progress/kendo-react-data-tools'
import { useAppSelector } from 'store'

import { SelectFilter } from '../SelectFilter'

export const MLStatusFilter: React.FC<TextFilterProps> = (props) => {
  const { filter, onFilterChange } = props
  const mlStatuses = useAppSelector((state) => state.tickets.mlStatuses)

  const data = mlStatuses.map((status) => ({
    id: status.id,
    label: status.name,
    value: status.id,
  }))

  return (
    <SelectFilter
      placeholder='ML Status'
      filter={filter}
      onFilterChange={onFilterChange}
      data={data}
    />
  )
}
